import { sanitizeReportHtml } from 'src/app/shared/helpers/report-html-sanitizer.helper';

/** Builds the hidden, live-document container that widgets render into while their snapshots are
 * captured. Moving parsed nodes into a live-document element adopts them and lets handlers such as
 * <img onerror> run, so the stored template is sanitized first; widget tags and their option
 * attributes survive sanitizing. */
export function createWidgetSnapshotContainer(layoutHtml: string): HTMLDivElement {
  const parsed = new DOMParser().parseFromString(sanitizeReportHtml(layoutHtml), 'text/html');
  const container = document.createElement('div');
  container.style.visibility = 'hidden';
  container.style.position = 'fixed';
  container.style.top = '-9999px';
  Array.from(parsed.body.childNodes).forEach(node => container.appendChild(node));
  return container;
}
